
import React, { useEffect, useState } from 'react';
import { cmsDetailsAction } from '../../../features/webCommonSlice';
import moment from 'moment';
import CmsPageShimmer from '../CmsPageShimmer/CmsPageShimmer';

const RefundsAndCancellations = () => {
    const [loader, setLoader] = useState(false)
    const [cmsDetails, setCmsDetails] = useState({});

    useEffect(() => {
        setLoader(true)
        cmsDetailsAction({ slug: "refund-cancellation" }, (response) => {
            if (response?.status === true) {
                setCmsDetails(response?.data)
            }
            setLoader(false)
        })();
    }, [cmsDetailsAction])

    return (
        <>
            <div className='cms_landing_page'>
                <div className='banner'>
                    Refund & Cancellation
                    {/* {cmsDetails.title} */}
                    {/* {cmsDetails?.updatedAt ? moment(cmsDetails.updatedAt).format("YYYY-MM-DD") : "-"} */}
                </div>
                <div className='container'>
                    {/* {!loader ?
                        <div className='cms_content_text'>
                            <div dangerouslySetInnerHTML={{ __html: cmsDetails.description }}></div>
                        </div>
                        :
                        <>
                            <CmsPageShimmer />
                        </>
                    } */}
                    <div className="cms_content_text">
                        <p>a) In the event, that there is an error in the Services provided by us, we may refund the Entry Fee, provided the reasons are genuine and proved after investigation by Millionaire11.</p>
                        <p>b) Please read the rules of each Game and Contest before participating.</p>
                        <p>c) We do not cancel registrations once entered, however, in case of exceptional circumstances wherein the fault may lie with the payment gateway or from Our side, We will cancel your participation on request and refund the Entry Fee to You within a reasonable amount of time.</p>
                        <p>d) In case we cancel your participation in any Game or Contest as a result of this, We will return Your Entry Fee to You within a reasonable amount of time for You to redeem the same by playing other Contests on Millionaire11.</p>
                        <p>e) We will try Our best to create the best user experience for You. If paid by credit card, refunds will be issued to the original credit card provided at the time of purchase and in case of payments made through a payment gateway, payment refunds will be made to the same account.</p>
                        <p>f) All deposits and purchases made and fees paid on Millionaire11 to play or in connection with Fantasy Cricket are final. All transactions are final. Only error-oriented transaction cases shall be reviewed.</p>
                        <p>g) If you are not fully satisfied with any deposit/purchase made or fee paid on Millionaire11 and feel there is an \'Error’ in the transaction(s), please let us know about that within 3 days from the transaction date, and we shall certainly review the transaction and determine the resolution at our own discretion.</p>
                        <p>Users must use any money in their Account within 365 days. Millionaire11 shall have the right to directly forfeit any such unused amount after 365 (three hundred and sixty five) days. The idle Balance amount lying in your account may be withdrawn only in exceptional circumstances, determined on a case to case basis on the sole discretion of Millionaire11.</p>
                        <p>h) Once the refund request is approved, The Refunded Amount will be processed and credited within 2 Days to the original mode of payment.</p>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RefundsAndCancellations